// app/components/Plugins/Automations/nodes/StopNode.tsx
'use client'

import React from 'react'
import { Handle, Position } from '@xyflow/react'
import { NodeProps, StopNodeData } from '../types'

const StopNode: React.FC<NodeProps<StopNodeData>> = ({ data, isConnectable }) => {
  return (
    <div className="node stopNode">
      <div className="node-header">Stop</div>
      <div className="node-content">
        <div 
          className="stop-indicator"
          style={{
            backgroundColor: '#ef5350', // Red color
            padding: '8px 12px',
            borderRadius: '4px',
            textAlign: 'center',
            fontWeight: 'bold',
            color: '#fff',
            marginTop: '8px',
            marginBottom: '8px'
          }}
        >
          STOP EXECUTION
        </div>
        <div className="label-text" style={{ fontSize: '11px', color: '#aaa', textAlign: 'center' }}>
          Stops the flow when this node is reached
        </div>
      </div>
      
      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Left}
        id="in"
        isConnectable={isConnectable}
      />
    </div>
  )
}

export default StopNode